import css from 'styled-jsx/css'

export default css`
  .container {
    position: fixed;
    top: env(safe-area-inset-top, 0px);
    left: 50%;
    z-index: 1000;
    transform: translate3d(-50%, 0, 0);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .message {
    position: relative;
    z-index: 2;
    display: flex;
    border-radius: 8px;
    padding: 5px 8px;
    background-color: rgba(0, 0, 0, 0.85);
    gap: 10px;
    align-items: center;
    color: #fff;
    opacity: 0;
  }
  .message-icon {
    width: 24px;
    height: 24px;
  }
`
